/* eslint-disable */
export default {
  title: '透過語音訊息回覆',
  customMessage: '自訂訊息',
  customMessagePlaceholder: '輸入自訂訊息',
} as const;

// @key: @#@"title"@#@ @source: @#@"Reply with Voice Message"@#@
// @key: @#@"customMessage"@#@ @source: @#@"Custom message"@#@
// @key: @#@"customMessagePlaceholder"@#@ @source: @#@"Type a custom message"@#@
